import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { CaptureBase, commonClass, Company, notificationDM, notificationDocComments, notificationDocNew } from '../models/commonClass';
import { ErrorShowService } from './error-show.service';
import { NavbarDateShareService } from './navbar-date-share.service';
import { SharedALLService } from './shared-all.service';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  constructor(private http: HttpClient, private tokenService: TokenService, private shareService: SharedALLService, private errorShowService: ErrorShowService, private router: Router, private navShareService: NavbarDateShareService) { }
  redirectLogin() {
    this.router.navigate(['/login']);
  }
  getProductProfileDetails(documentid) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('documentid', documentid);

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'product_profile.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  getWorkshopDetails(documentid) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('documentid', documentid);

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'workshop_list.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  getNewsLetterDetails(documentid) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('documentid', documentid);
    var apiRequest2 = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID());

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'newsletter.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }


  getEchoDetails(documentid , currentStateId , tagSelect) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('documentid', documentid)
      .set('recorder', 1)
      .set('doctypeid', commonClass.DOCUMENT_TYPE_ECHO)
      .set('stateid', currentStateId);
      if(tagSelect != 'All'){
         apiRequest = apiRequest.append('search', '#' + tagSelect);
      }


    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'intel.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  // https://cip.medsphere.net/FCM/clinical_trial.php?documentid=68541&userid=2444&subprojectid=79
  getProductDetailsDetails(documentid) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('documentid', documentid);

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'product_detail.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }
  // https://cip.medsphere.net/FCM/product_detail.php?&documentid=68847&userid=2444&subprojectid=79
  getClinicalTrailDetails(documentid) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('documentid', documentid);

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'clinical_trial.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }


  getOtherCategoryDetails(documentid, doctypeid,spID?) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', spID ? spID : this.tokenService.getSubprojectID())
      .set('doctypeid', doctypeid)
      .set('timestamp', 0)
      .set('securelvl', 3)
      .set('documentid', documentid);

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'intel.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  getAllDMmessageList() {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID());
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'dm_history.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          //self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  getChatDetails(groupid) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('groupid', groupid);

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'common_get_dm_data.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  disableEnableDeleteTotalChat(groupid, status) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('groupid', groupid)
      .set('status', status);

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'manage_dm.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }
  getParticipantListFoeIndividualGroup(groupid) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('groupid', groupid);

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'dm_group_users.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }
  deleteParticipantFromGroup(groupid, deleteduserid) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('groupid', groupid)
      .set('users[]', deleteduserid);

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'delete_dm_group_users.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }


  getAllUserListForIndividualUser() {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID());


    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'dm_users.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  getCongressUserListForIndividualUser(congressId) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('congress', congressId);

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'dm_users.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  getGroupListForIndividualUser(groupid) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('groupid[]', groupid);

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'dm_users.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }


  addParticipantsInGroup(userId, groupId) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('users[]', userId)
      .set('groupid', groupId)

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'add_user_to_group.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  deleteIndividualMessageCHAT(Id) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('id', Id)

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'delete_dmessage.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }
  deleteIndividualMessagImage(Id, path) {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('id', Id)
      .set('path', path)

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'delete_dmessage.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }
  calltimelineApi(doctypeid, sortOrder, startDate = "", endDate = "", categoryid = '', brandid = '', sponsorid = '', indicationid = '', countryid = '', phaseid = '') {
    var apiRequest = new HttpParams()
      .set('userid', this.tokenService.getUserId())
      .set('subprojectid', this.tokenService.getSubprojectID())
      .set('doctypeid', doctypeid)
      .set('sort', sortOrder)
      .set('startdate', startDate)
      .set('enddate', endDate)
      .set('brandid', brandid)
      .set('sponsorid', sponsorid)
      .set('indicationid', indicationid)
      .set('countryid', countryid)
      .set('categoryid', categoryid)
      .set("phaseid", phaseid)

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI('POST', 'timeline_v3.php', apiRequest).subscribe(data => {
        if (data['STATUS'] == "1") {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }


  createNewDm(receiverId, popupGroupTitle, newMessage) {
    var apiRequest = new HttpParams()
      .set("congressid", "")
      .set("sender", this.tokenService.getUserId())
      .set("receiver[]", receiverId.slice(0, -1))
      .set("gname", popupGroupTitle)
      .set("message", newMessage)
      .set("userid", this.tokenService.getUserId())
      .set("subprojectid", this.tokenService.getSubprojectID())

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "dm.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }


  errorCheckRedirection(data) {
    console.log(data)
    if (data['STATUS'] == '0') {// && data['MESSAGE'] === 'Invalid' && data['DATA'] === null) {
      //this.router.navigate(["/"])
      //window.location.reload();
      this.errorShowService.showError(data["MESSAGE"]);
    }
    else if (parseInt(data['STATUS']) === 0) {
      console.log(132)
      this.errorShowService.showError(data["MESSAGE"]);
    }
  }


  callCongressListAPI(status?: number) {
    var apiRequest = new HttpParams()
      .set("userid", this.tokenService.getUserId())
      .set("subprojectid", this.tokenService.getSubprojectID())
    if (status !== undefined && status !== null ) {
      apiRequest = apiRequest.set("congress_status", status.toString());
    }
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "select_conference.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  mainSessionCallAPI(CONGRESSID) {
    var apiRequest = new HttpParams()
      .set("userid", this.tokenService.getUserId())
      .set("subprojectid", this.tokenService.getSubprojectID())
      .set("congressid", CONGRESSID)
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "planner.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  subSessionCallAPI(CONGRESSID) {
    var apiRequest = new HttpParams()
      .set("userid", this.tokenService.getUserId())
      .set("congressid", CONGRESSID)
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "subsession.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      },
        error => {
          console.log(error)
          reject(error['message'])
        });
    });
  }

  mainProcessbookmarkAPI(CONGRESSID, DOCUMENTID, APINAME) {
    var apiRequest = new HttpParams()
      .set("userid", this.tokenService.getUserId())
      .set("congressid", CONGRESSID)
      .set("documentid", DOCUMENTID)
      .set("subprojectid", this.tokenService.getSubprojectID())
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", APINAME, apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  subProcessbookmarkAPI(CONGRESSID, PRESENTATIONID, APINAME) {
    var apiRequest = new HttpParams()
      .set("userid", this.tokenService.getUserId())
      .set("congressid", CONGRESSID)
      .set("presentationid", PRESENTATIONID)
      .set("subprojectid", this.tokenService.getSubprojectID())
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", APINAME, apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  uploadListDataAPI(CONGRESSID) {
    var apiRequest = new HttpParams()
      .set("userid", this.tokenService.getUserId())
      .set("congressid", CONGRESSID)
      .set("securelvl", 3)
      .set("subprojectid", this.tokenService.getSubprojectID())
      .set("timestamp", 0)
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "intel.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  bookmarkDataAPI(CONGRESSID, RID) {
    var apiRequest = new HttpParams()
      .set("userid", this.tokenService.getUserId())
      .set("congressid", CONGRESSID)
      //.set("securelvl", 3)
      .set("subprojectid", this.tokenService.getSubprojectID())
      .set("doctypeid", commonClass.CONGRESS_REPORT)// + "," + commonClass.OTHER_REPORTS)
    //.set("timestamp", 0)
    //.set("rid", RID)
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "intel.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }



  callCommentAPI(CONGRESSID, PRESENTATIONID, DOCUMENTID) {
    var apiRequest = new HttpParams()
      .set("userid", this.tokenService.getUserId())
      .set("congressid", CONGRESSID)
      .set("presentationid", PRESENTATIONID)
      .set("subprojectid", this.tokenService.getSubprojectID())
      .set("documentid", DOCUMENTID);
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "common_get_chat_data.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  callNotesAPI(CONGRESSID, PRESENTATIONID) {
    var apiRequest = new HttpParams()
      .set("userid", this.tokenService.getUserId())
      .set("congressid", CONGRESSID)
      .set("presentationid", PRESENTATIONID)

    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "view_cong_notes.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  callAddNotesAPI(CONGRESSID, PRESENTATIONID, NOTES, DOCUMENTID) {
    var apiRequest = new HttpParams()
      .set("congressid", CONGRESSID)
      .set("presentationid", PRESENTATIONID)
      .set("notes", NOTES)
      .set("documentid", DOCUMENTID)
      .set("userid", this.tokenService.getUserId())
      .set("notify", 1)
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "insert_cong_notes.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  callMySheduleAPI(CONGRESSID) {
    var apiRequest = new HttpParams()
      .set("congressid", CONGRESSID)
      .set("userid", this.tokenService.getUserId())
    // .set("subprojectid", this.tokenService.getSubprojectID())
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "view_user_bookmarks.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }


  callSesisonLocationAPI(CONGRESSID) {
    var apiRequest = new HttpParams()
      .set("congressid", CONGRESSID)
    // .set("subprojectid", this.tokenService.getSubprojectID())
    // .set("userid", this.tokenService.getUserId())
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "congress_loc_type.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }


  callParticipantAPI(CONGRESSID) {
    var apiRequest = new HttpParams()
      .set("userid", this.tokenService.getUserId())
      .set("congressid", CONGRESSID)
      .set("congress", 1)
      .set("subprojectid", this.tokenService.getSubprojectID())
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "congress_attendees.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  callplannerAPI(CONGRESSID, TITLE, DATE, SIME, ETIME, LOACTIONID, TYPE) {
    var apiRequest = new HttpParams()
      .set("userid", this.tokenService.getUserId())
      .set("congressid", CONGRESSID)
      .set("title", TITLE)
      .set("date", DATE)
      .set("stime", SIME)
      .set("etime", ETIME)
      .set("locationid", LOACTIONID)
      .set("type", TYPE)
      .set("subprojectid", this.tokenService.getSubprojectID())
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "add_planner.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  callUserApi(CONGRESSID) {
    var apiRequest = new HttpParams()
      .set("userid", this.tokenService.getUserId())
      .set("congressid", CONGRESSID)
      .set("subprojectid", this.tokenService.getSubprojectID());
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "DM_Users.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  callGroupUserApi(GROUPID) {
    var apiRequest = new HttpParams()
      .set("groupid[]", GROUPID)
      .set("userid", this.tokenService.getUserId())
      .set("congress", 1)
      .set("subprojectid", this.tokenService.getSubprojectID());
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "DM_Users.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  callAddParticipantTo(PRESENTATIONIDS, USERIDS, CONGRESSID) {
    var apiRequest = new HttpParams()
      .set("presentationid[]", PRESENTATIONIDS)
      .set("userid[]", USERIDS)
      .set("congressid", CONGRESSID)
      .set("subprojectid", this.tokenService.getSubprojectID());
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService.callAPI("POST", "admin_bookmark.php", apiRequest).subscribe(data => {
        if (data['STATUS'] == 1) {
          resolve(data);
        }
        else {
          self.errorCheckRedirection(data)
          reject(data['MESSAGE'])
        }
      });
    });
  }

  getAllDetailsData(documentID, doctypeID,spID?) {
    if (doctypeID) {
      //if (doctypeID === commonClass.WORKSHOP_DETAIL.toString()) {
      //  let self = this;
      //  return new Promise(function (resolve, reject) {
      //    self.getWorkshopDetails(documentID)
      //      .then(function (res) {
      //        resolve(res['DATA']);
      //      })
      //      .catch(function (error) {
      //        self.errorShowService.showError(error);
      //        reject(error)
      //      })
      //  });
      //}
      //else if (doctypeID === commonClass.PRODUCT_PROFILE.toString()) {
      //  let self = this;
      //  return new Promise(function (resolve, reject) {
      //    self.getProductProfileDetails(documentID)
      //      .then(function (res) {
      //        resolve(res['DATA']);
      //      })
      //      .catch(function (error) {
      //        self.errorShowService.showError(error);
      //        reject(error)
      //      })
      //  });
      //}
      //else if (doctypeID === commonClass.DOCUMENT_TYPE_NEWS_LETTERS.toString()) {
      //  let self = this;
      //  return new Promise(function (resolve, reject) {
      //    self.getNewsLetterDetails(documentID)
      //      .then(function (res) {
      //        resolve(res['DATA']);
      //      }).catch(function (error) {
      //        self.errorShowService.showError(error);
      //        reject(error)
      //      })
      //  });
      //} else if (doctypeID === commonClass.CLINICAL_TRIAL.toString()) {
      //  let self = this;
      //  return new Promise(function (resolve, reject) {
      //    self.getClinicalTrailDetails(documentID)
      //      .then(function (res) {
      //        resolve(res['DATA']);
      //      }).catch(function (error) {
      //        self.errorShowService.showError(error);
      //        reject(error)
      //      })
      //  });
      //}
      //else
        if (doctypeID === commonClass.PRODUCT_DETAILS.toString()) {
        let self = this;
        return new Promise(function (resolve, reject) {
          self.getProductDetailsDetails(documentID)
            .then(function (res) {
              resolve(res['DATA']);
            }).catch(function (error) {
              self.errorShowService.showError(error);
              reject(error)
            })
        });
      }  else if (doctypeID === commonClass.CLINICAL_TRIAL.toString()) {
        let self = this;
        return new Promise(function (resolve, reject) {
          self.getClinicalTrailDetails(documentID)
            .then(function (res) {
              resolve(res['DATA']);
            }).catch(function (error) {
              self.errorShowService.showError(error);
              reject(error)
            })
        });
      }else if (doctypeID === commonClass.PRODUCT_PROFILE.toString()) {
        let self = this;
        return new Promise(function (resolve, reject) {
          self.getProductProfileDetails(documentID)
            .then(function (res) {
              resolve(res['DATA']);
            }).catch(function (error) {
              self.errorShowService.showError(error);
              reject(error)
            })
        });
      }
      else {
        let self = this;
        return new Promise(function (resolve, reject) {
          self.getOtherCategoryDetails(documentID, doctypeID,spID).then(function (res) {
            console.log(res)
            resolve(res['DATA']);
          })
            .catch(function (error) {

              reject(error)
            })

        });
      }
    }
    else {
      this.errorShowService.showError("Invalid Query Parameter");
      return null;
    }

  }

  getColorCode(x, y) {
    return commonClass.ApexchartColorCodes;
  }

  likeFunction(data, type) {
    switch (type) {
      case 'NO': {
        const body = new HttpParams()
          .set('like', commonClass.unlikeUnfav)
          .set('documentid', data.DOCUMENTID)
          .set('userid', this.tokenService.getUserId());

        this.shareService.callAPI('POST', 'favlike.php', body).subscribe(
          (res) => {
            data.LIKES = parseInt(data.LIKES) - 1;
            data.MYLIKES = 'NO';
            return data;
          },
          (error) => {
            this.errorShowService.showError(error['message']);
          }
        );
        return "";
        break;
      }
      case 'YES': {
        const body = new HttpParams()
          .set('like', commonClass.likeFav)
          .set('documentid', data.DOCUMENTID)
          .set('userid', this.tokenService.getUserId());

        this.shareService.callAPI('POST', 'favlike.php', body).subscribe(
          (res) => {
            data.LIKES = parseInt(data.LIKES) + 1;
            data.MYLIKES = 'YES';
            return data;
          },
          (error) => {
            this.errorShowService.showError(error['message']);

          }
        );
        return "";
        break;
      }
      default:
        return "";
    }
  }

  productprofileKey: string = commonClass.ppTerm;
  ClinicalKey: string = commonClass.ctTerm;
  GalleryKey: string = commonClass.galleryTerm;
  ReportsKey: string = commonClass.reportTerm;
  NewsKey: string = commonClass.newsTerm;
  UpcomingKey: string = commonClass.eventTerm;
  KitsKey: string = commonClass.kitsTerm;
  PastKey: string = commonClass.peventTerm;

  viewAllInDashboard(key) {
    if (key == this.productprofileKey) {
      this.router.navigateByUrl("/dashboard/productprofile")
    }
    else if (key == this.ClinicalKey) {
      this.router.navigateByUrl("/dashboard/clinicaltrails")
    }
    else if (key == this.NewsKey) {
      this.router.navigateByUrl("/dashboard/news")
    } else if (key == this.GalleryKey) {
      this.router.navigateByUrl("/dashboard/gallery")
    }
    else if (key == this.ReportsKey) {
      this.router.navigateByUrl("/dashboard/report")
    } else if (key == this.KitsKey) {
      this.router.navigateByUrl("/dashboard/kits")
    } else if (key == this.UpcomingKey) {
      this.router.navigateByUrl("/dashboard/upcoming")
    }
    else if (key == this.PastKey) {
      this.router.navigateByUrl("/dashboard/past")
    }
    else {
      this.router.navigateByUrl("/dashboard/gallery")
    }
  }

  getBaseDataCapture() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.shareService
        .callAPI('GET', 'all_bis.php', '')
        .subscribe((dataResponse) => {
          if (dataResponse['STATUS'] == 1) {
            var baseData = dataResponse['DATA'] as CaptureBase;
            if (baseData) {
              self.tokenService.setBaseData(baseData);
              self.tokenService.setGroupData(baseData.GROUP)
            }
            resolve(baseData);
          } else {
            this.router.navigateByUrl('/login');
            self.errorCheckRedirection(dataResponse)
            reject(dataResponse['MESSAGE'])
          }
        });
    });
  }

  //=============Notification........
  proceedForDMNotification(dmObj: notificationDM) {
    if (commonClass.getThisPageName(this.router.url) == "direct-message") {
      dmObj['isCurrentPage'] = true;
      this.navShareService.setdmNotify(dmObj);
    }
    else {
      if (dmObj.title) {
        this.errorShowService.showMessage(dmObj.title, dmObj.body).onTap.subscribe(data => {
          dmObj['isCurrentPage'] = false;
          this.navShareService.setdmNotify(dmObj);
          this.router.navigateByUrl("/dashboard/direct-message")
        })
      }
      //this.errorShowService.showMessage(dmObj.message.notification.title, dmObj.message.notification.body).onTap.subscribe(data => {
      //  dmObj['isCurrentPage'] = false;
      //  this.navShareService.setdmNotify(dmObj);
      //  this.router.navigateByUrl("/dashboard/direct-message")
      //})
    }
  }
  proceedForDocNotification(docObj: notificationDocNew) {
    this.errorShowService.showMessage(docObj.message.notification.title, docObj.message.notification.body).onTap.subscribe(data => {
      this.navShareService.setdocNotify(docObj);
    });
  }
  proceedForDocCommentNotification(comObj: notificationDocComments) {
    if (commonClass.getThisPageName(this.router.url).includes("detail")) {
      var arr = commonClass.getThisPageName(this.router.url).split('=')
      var docid = arr[arr.length - 1];
      if (docid == comObj.id) {
        this.navShareService.setcomNotify(comObj);
      }
    }
    else {
      this.errorShowService.showMessage(comObj.message.notification.title, comObj.message.notification.body).onTap.subscribe(data => {
        window.open(commonClass.createDetailScreenUrl(comObj.doctypeid, comObj.id))
      });
    }
  }

  //===============Company name and logo================
  getPrimaryCompany(item) {
    if (item["COMPANY"]) {
      var companyList: [Company] = item["COMPANY"];
      if (companyList.length > 0) {
        return companyList.filter(x => x["PRIMARY"] == "1").length > 0 ? companyList.filter(x => x["PRIMARY"] == "1")[0] : null
      }
    }
    return null;
  }
  getCompanyName(item) {
    let company = this.getPrimaryCompany(item);
    return company ? company["SPONSORNAME"] : '';
  }
  getCompanyLogo(item) {
    if (item["DOCTYPEID"] == commonClass.PRODUCT_PROFILE && !item["COMPANY"]) {
      let company = item;
      return company && company['COMPANY_LOGO'] != null ? environment.companyUrl + company['COMPANY_LOGO'] : commonClass.noImage;
    }
    else {
      let company = this.getPrimaryCompany(item);
      return company && company['COMPANY_LOGO'] != null ? environment.companyUrl + company['COMPANY_LOGO'] : commonClass.noImage;
    }
  }


  async getCountriesData() {
    const url = "https://restcountries.com/v3.1/all?fields=cca2,flag,name,common";
    try {

      this.http.get(url).subscribe(x => {
        localStorage.setItem('countriesData', JSON.stringify(x))
        return x;
      })

    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Rethrow the error to propagate it
    }
  }
  getIndicationButtons(ppData) {
    let indication = new Map();
    ppData.forEach(pd => {
      pd['PRODUCT_DETAIL'].forEach(d => {
        indication.set(d['INDICATIONID'], d['INDICATIONNAME'])
      })
    })

    let indicationButton = []; let i = 0;
    for (let e of Array.from(indication.entries())) {
      let obj = {
        INDICATIONID: e[0],
        INDICATIONNAME: e[1],
        color: commonClass.ApexchartColorCodes[commonClass.ApexchartColorCodes.length - i]
      }
      indicationButton.push(obj);
      i++;
    }
    return indicationButton;
  }

  startApiChatCall(documentid) {
    let self = this;
    return new Promise(function (resolve, reject) {
      const body = new HttpParams()
        .set('documentid', documentid)
      self.http.post(environment.baseUrl + commonClass.chatbotListApi, body).subscribe(data => {
        console.log(data);
        if (data['STATUS']) {
          resolve(data);
        }
      }, error => {
        reject(error)
      })
    });
  }

  getOtherDocPathSet(filterData: Array<Object>) {
    return new Promise(function (resolve, reject) {
      filterData.forEach((item, index) => {
        item['OTHERDOCUMENTS'] = [];
        if (item['PATH']) {
          let imagepath = item['PATH'];
          let pathList = imagepath.split(',');
          item['PATH'] = '';
          pathList.forEach((itemFile) => {
            let extentionType = itemFile.split('.').pop();
            if (commonClass.allImages.indexOf(extentionType) != -1) {
              item['PATH'] += itemFile;
              item['PATH'] += ',';
            } else {
              item['OTHERDOCUMENTS'].push(itemFile);
            }
          });
          item['PATH'] = item['PATH'].slice(0, -1);
        }

        if (index == filterData.length - 1) {
          resolve(filterData);
        }

      });
    });
  }
}
